<template>
  <div v-if="charactersList.length" :style="themableStyle" class="theme-color">
    <transition-group
      @before-leave="beforeLeave"
      name="list"
      tag="div"
      class="columns is-vcentered is-centered is-marginless"
    >
      <div class="column has-text-right is-narrow" :key="-1">
        <a v-if="charactersCount > 4" @click="decreaseOffset">
          <b-icon type="is-primary" icon="chevron-left"></b-icon>
        </a>
      </div>
      <router-link
        v-if="getCharacter(0) || getVersion(0) || getUniverse(0)"
        :to="{ path: `/projects/${getCharacterId(0)}` }"
        class="column has-text-centered list-item is-one-fifth"
        :key="getCharacterId(0)"
      >
        <div class="box is-primary has-text-white">
          <p>
            <span class="ellipsis">
              <b-icon icon="account-circle-outline"></b-icon> {{ getCharacter(0) }}<br />
            </span>
            <span class="ellipsis">
              <b-icon icon="palette-swatch-outline"></b-icon> {{ getVersion(0) }}<br />
            </span>
            <span class="ellipsis">
              <b-icon icon="google-earth"></b-icon> {{ getUniverse(0) }}
            </span>
          </p>
        </div>
      </router-link>

      <router-link
        v-if="charactersCount > 1 && (getCharacter(1) || getVersion(1) || getUniverse(1))"
        :to="{ path: `/projects/${getCharacterId(1)}` }"
        class="column has-text-centered list-item is-one-fifth"
        :key="getCharacterId(1)"
      >
        <div class="box is-primary has-text-white">
          <p>
            <span class="ellipsis">
              <b-icon icon="account-circle-outline"></b-icon> {{ getCharacter(1) }}<br />
            </span>
            <span class="ellipsis">
              <b-icon icon="palette-swatch-outline"></b-icon> {{ getVersion(1) }}<br />
            </span>
            <span class="ellipsis">
              <b-icon icon="google-earth"></b-icon> {{ getUniverse(1) }}
            </span>
          </p>
        </div>
      </router-link>

      <router-link
        v-if="charactersCount > 2 && (getCharacter(2) || getVersion(2) || getUniverse(2))"
        :to="{ path: `/projects/${getCharacterId(2)}` }"
        class="column has-text-centered list-item is-one-fifth"
        :key="getCharacterId(2)"
      >
        <div class="box is-primary has-text-white">
          <p>
            <span class="ellipsis">
              <b-icon icon="account-circle-outline"></b-icon> {{ getCharacter(2) }}<br />
            </span>
            <span class="ellipsis">
              <b-icon icon="palette-swatch-outline"></b-icon> {{ getVersion(2) }}<br />
            </span>
            <span class="ellipsis">
              <b-icon icon="google-earth"></b-icon> {{ getUniverse(2) }}
            </span>
          </p>
        </div>
      </router-link>

      <router-link
        v-if="charactersCount > 3 && (getCharacter(3) || getVersion(3) || getUniverse(3))"
        :to="{ path: `/projects/${getCharacterId(3)}` }"
        class="column has-text-centered list-item is-one-fifth"
        :key="getCharacterId(3)"
      >
        <div class="box is-primary has-text-white">
          <p>
            <span class="ellipsis">
              <b-icon icon="account-circle-outline"></b-icon> {{ getCharacter(3) }}<br />
            </span>
            <span class="ellipsis">
              <b-icon icon="palette-swatch-outline"></b-icon> {{ getVersion(3) }}<br />
            </span>
            <span class="ellipsis">
              <b-icon icon="google-earth"></b-icon> {{ getUniverse(3) }}
            </span>
          </p>
        </div>
      </router-link>

      <div class="column has-text-left is-narrow" :key="-2">
        <a v-if="charactersCount > 4" @click="increaseOffset">
          <b-icon type="is-primary" icon="chevron-right"></b-icon>
        </a>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { themableMixin } from '@/mixins/themableMixin'
export default {
  mixins: [themableMixin],
  props: ['charactersList', 'user'],
  data () {
    return {
      offset: 0
    }
  },
  computed: {
    charactersCount () {
      return this.charactersList.length
    },
    themableTheme () {
      return this.user ? this.user.theme.name : null
    }
  },

  methods: {
    getCharacter (position) {
      let offetPosition = (position + this.offset) % this.charactersList.length
      return this.charactersList[offetPosition].attributes.character
    },
    getVersion (position) {
      let offetPosition = (position + this.offset) % this.charactersList.length
      return this.charactersList[offetPosition].attributes.version
    },
    getUniverse (position) {
      let offetPosition = (position + this.offset) % this.charactersList.length
      return this.charactersList[offetPosition].attributes.universe
    },
    getCharacterId (position) {
      let offetPosition = (position + this.offset) % this.charactersList.length
      return this.charactersList[offetPosition].id
    },
    increaseOffset () {
      this.offset = this.offset + 1
    },
    decreaseOffset () {
      if (this.offset === 0) this.offset = this.charactersCount - 1
      else this.offset--
    },
    // Transitions
    beforeLeave (el) {
      const { marginLeft, marginTop, width, height } = window.getComputedStyle(el)
      el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
      el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
      el.style.width = width
      el.style.height = height
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  transition: all 1s;
}
.list-move {
  transition: all 1s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}

.list-enter-active {
  transition: opacity 0.3s;
  opacity: 0;
}

.list-leave-active {
  transition: opacity 0.3s;
  opacity: 0;
  position: absolute;
}
.fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
</style>
